import * as React from "react";
import { useState, useEffect } from "react";
import { useAdminAccountFilterStore } from "src/hooks/admin/adminAccountFilter";
import { useAdminCommonStore } from "src/hooks/admin/adminCommon";
import Helper from "src/support/Helper";
import useReduxState from "src/hooks/useReduxState";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { DateRangePicker } from 'rsuite';
import { useDesignHubStore } from "src/hooks/designHub";

export function SearchAcct() {
  const [{ orgList }, { get_organization_detail }, { }] = useAdminCommonStore();
  const defaultModel = {
    accountName: "",
    accountNumber: "",
    speedboat: "",
    salesOrg: [],
    isAccountActive: "",
    country: [],
    createdDate: ""
  };
  const [searchData, setSearchData] = useState(defaultModel);
  const [{ filter_list }, { }, { set_filter_list }] = useAdminAccountFilterStore();
  const [userListErrAlert, setUserListErrAlert] = useReduxState("", "setUserListErrAlert");
  const [errAlertType, setErrAlertType] = useReduxState("", "setErrAlertType");
  const [{ countryList }, { get_country_list }, { }] = useDesignHubStore();

  useEffect(() => {
    async function fetchHere() {
      get_organization_detail();
      get_country_list();
    }
    fetchHere();
  }, []);

  useEffect(() => {
    if (!filter_list || Object.entries(filter_list).length === 0) {
      setSearchData(defaultModel);
    } else {
      const searchingData = defaultModel;

      searchingData.accountName = filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : '';
      searchingData.accountNumber = filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : '';
      searchingData.speedboat = filter_list?.speedboat?.searchKeyword ? filter_list?.speedboat?.searchKeyword : '';
      searchingData.salesOrg = filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr : [];
      searchingData.isAccountActive = filter_list?.accountActive?.searchKeyword ? filter_list?.accountActive?.searchKeyword : '';
      searchingData.country = filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr : [];
      searchingData.createdDate = filter_list?.createdDate?.searchKeyword ? filter_list?.createdDate?.searchKeyword : null;
      setSearchData(searchingData);
    }

  }, [filter_list]);

  const onSearch = (e) => {
    e.preventDefault();

    const isSearchDataEmpty = Object.values(searchData).every(
      (value) => !value
    );

    if (isSearchDataEmpty) {
      setUserListErrAlert(
        "At least one of the fields (Account Name or Account Number) should have search keywords to display results",
        "danger",
        "searchUser"
      );
      setErrAlertType("danger");
      return;
    }

    const keyToSearchType = {
      accountName: "Account Name",
      accountNumber: "Account Number",
      speedboat: "Speedboat",
      salesOrg: "Sales Org",
      isAccountActive: "Account Active",
      createdDate: "Created Date",
      country: "Country"
    };
    const filterList = Object.entries(searchData)
      .filter(([key, value]) => Helper.valueIsNotNull(value))
      .map(([key, value]) => {
        let val = {
          searchType: keyToSearchType[key]
        };
        switch (key) {
          case 'country':
          case 'salesOrg':
            val['searchKeywordArr'] = value?.map((v) => ({ label: v?.label?.trim(), value: v?.value?.trim() }));
            break;
          default:
            val['searchKeyword'] = value?.trim();
            break;
        }
        return val;
      });
    const toCamelCase = (str) => {
      return str
        ?.toLowerCase()
        ?.replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr?.toUpperCase());
    };
    const filterListObject = filterList?.reduce((acc, curr) => {
      const key = toCamelCase(curr?.searchType);

      if (key === "salesOrg") {
        acc[key] = {
          searchType: curr?.searchType,
          searchKeywordArr: curr?.searchKeywordArr
        };
      } else if (key === "country") {
        acc[key] = {
          searchType: curr?.searchType,
          searchKeywordArr: curr?.searchKeywordArr
        };
      } else {
        acc[key] = {
          searchType: curr?.searchType,
          searchKeyword: curr?.searchKeyword
        };
      }
      return acc;
    }, {});

    const accountNumberLength = searchData?.accountNumber?.length;
    if (accountNumberLength && accountNumberLength < 2) {
      setUserListErrAlert(
        "Enter at least 2 characters without zero",
        "danger",
        "searchAccount"
      );
      setErrAlertType("danger");
      return;
    }

    if (!filterListObject.hasOwnProperty('speedboat')) {
      setUserListErrAlert(
        "Please select Speedboat",
        "danger",
        "searchAccount"
      );
      setErrAlertType("danger");
      return;
    }

    if (filterListObject.hasOwnProperty('accountNumber')) {
      if (!/^(?!0+$)[0-9]+$/.test(filterListObject.accountNumber.searchKeyword)) {
        setUserListErrAlert(
          "Enter keyword greater than zero",
          "danger",
          "searchAccount"
        );
        setErrAlertType("danger");
        return;
      }
    }
    // Clear Alert
    setUserListErrAlert("");
    setErrAlertType("");
    set_filter_list(filterListObject);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "accountNumber") {
      const truncatedValue = value.slice(0, 10); // Limit to 10 digits
      setSearchData((prevData) => ({
        ...prevData,
        [name]: truncatedValue
      }));
    } else {
      setSearchData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };
  return (
    <>
      <div className="bg-grey2">
        <div className="container">
          <div className="accordion-item ">
            <h2 className="accordion-header" id="searchInput">
              <button
                className="accordion-button"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSearch"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <b className="font-16">Search</b>
              </button>
            </h2>

            <div
              id="collapseSearch"
              className="accordion-collapse collapse in"
              aria-labelledby="searchInput"
              data-parent="#accordionExample"
            >
              <div className="accordion-body p-0">
                <form
                  onSubmit={(e) => {
                    onSearch(e);
                  }}
                >
                  <div className="row bs5 m-t-30 ms-0 me-0 usersearch-container">
                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="accountName">Account Name </label>
                      <input
                        className="ps-2 form-control form-control-sm mb-0"
                        name="accountName"
                        placeholder="Account Name"
                        type="text"
                        value={searchData.accountName}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="accountNumber">Account Number </label>
                      <input
                        className="ps-2 form-control form-control-sm mb-0 hidearrow"
                        name="accountNumber"
                        placeholder="Account Number"
                        type="number"
                        onKeyDown={event => ['e', 'E', '+', '-', '.']?.includes(event.key) && event.preventDefault()}
                        value={searchData.accountNumber}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="speedboat">Speedboat * </label>
                      <select
                        className="form-control form-control-sm"
                        name="speedboat"
                        value={searchData.speedboat}
                        onChange={handleInputChange}
                        defaultValue={""}
                      >
                        <option value={""}>Select a Speedboat</option>
                        <option value={"Silica"}>Silica</option>
                        <option value={"Abacus"}>Abacus</option>
                        <option value={"EBV"}>EBV</option>
                      </select>
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2 multiselect">
                      <label htmlFor="salesOrg">Sales Org </label>
                      <ReactMultiSelectCheckboxes
                        placeholderButtonLabel="Select Sales Org"
                        style={{ minWidth: "300px" }}
                        value={searchData.salesOrg}
                        options={
                          orgList &&
                          orgList.length > 0 &&
                          orgList.map((option) => ({
                            value: option,
                            label: option,
                          }))
                        }
                        onChange={(selectedOptions) => {
                          handleInputChange({
                            target: {
                              name: "salesOrg",
                              value: selectedOptions,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="isAccountActive">
                        Is Account Active?{" "}
                      </label>
                      <select
                        className="form-control form-control-sm"
                        name="isAccountActive"
                        value={searchData.isAccountActive}
                        onChange={handleInputChange}
                        defaultValue={""}
                      >
                        <option value={""}>Select Yes/No</option>
                        <option value={"Yes"}>Yes</option>
                        <option value={"No"}>No</option>
                      </select>
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2 multiselect">
                      <label htmlFor="country">Country </label>
                      <ReactMultiSelectCheckboxes
                        placeholderButtonLabel="Select Country"
                        style={{ minWidth: "300px" }}
                        value={searchData.country}
                        options={countryList}
                        onChange={(selectedOptions) => {
                          handleInputChange({
                            target: {
                              name: "country",
                              value: selectedOptions,
                            },
                          });
                        }}
                      />
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="createdDate">Created Date </label>
                      <DateRangePicker
                        format={Helper.getDatepickerFormat()}
                        placeholder="Month DD, YYYY"
                        character=" – "
                        cleanable={false}
                        editable={false}
                        value={searchData.createdDate ? searchData.createdDate.split(';')?.map(isoDate => new Date(isoDate)) : null}
                        onChange={dates => {
                          if (dates?.length === 2) {
                            const isoDateStringArray = [new Date(dates[0]), new Date(dates[1])].map(date => date?.toISOString())?.join(';')
                            handleInputChange({
                              target: {
                                name: "createdDate",
                                value: isoDateStringArray
                              }
                            })
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="row bs5 m-t-20">
                    <div className="col-sm-12 text-sm-end">
                      <button className="btn btn-secondary bs5">Search</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
